export default "__VITE_ASSET__Bhp386Kr__"